import { ZiroTextComponent } from '../../../../forms/fields/text/ziro-text.component';
import { Component } from '@angular/core';
import { ZiroFieldAbstractDirective } from '../../../../forms/ziro-field-abstract.directive';

@Component({
  selector: 'ziro-general-settings-text',
  templateUrl: './general-settings-text.component.html',
  styleUrls: ['./general-settings-text.component.scss'],
  providers: [{ provide: ZiroFieldAbstractDirective, useExisting: GeneralSettingsTextComponent }],
  standalone: false,
})
export class GeneralSettingsTextComponent extends ZiroTextComponent {}
